import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "@/pages/Portfolio";
import CaseStudy from "@/pages/CaseStudy";
import Services from "@/pages/Services";
import FishCaddyAudit from "@/pages/FishCaddyAudit";
import IdxBrokerAudit from "@/pages/IdxBrokerAudit";
import Seo from "@/components/Seo";
import { Toaster } from "@/components/ui/sonner";

const TOAST_OPTIONS = {
  className: "font-mono-ibm",
  style: {
    background: "#0A0A0A",
    color: "#FFFFFF",
    border: "1px solid #0A0A0A",
    borderRadius: 0,
    fontFamily: "IBM Plex Mono, monospace",
    fontSize: "12px",
    letterSpacing: "0.05em",
  },
};

function App() {
  return (
    <div className="App">
      <Toaster position="bottom-right" toastOptions={TOAST_OPTIONS} />
      <BrowserRouter>
        <Seo />
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/services" element={<Services />} />
          <Route path="/work/fishcaddy-ux-audit" element={<FishCaddyAudit />} />
          <Route path="/work/idx-broker-audit" element={<IdxBrokerAudit />} />
          <Route path="/work/:slug" element={<CaseStudy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
